module.exports = __webpack_public_path__ + "img/404.3ac179bd.svg";